import React from 'react';

import { Form, Radio } from 'antd';
import styled from 'styled-components';

import { CMA_SUMMARY_VIEW_FILTER_DISPLAY_COMPETITOR } from '../constants';

const Title = styled.div`
  letter-spacing: 0.5px;
  color: var(--text-primary);
  font-family: var(--font-bold);
  font-size: 12px;
  margin-bottom: 10px;
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const RadioButton = styled(Radio)`
  &&&.ant-radio-button-wrapper {
    font-size: 14px;
  }
`;

const CMASummaryViewFilterCompetitorsDisplay = () => (
  <div>
    <Title>COMPETITOR DISPLAY</Title>
    <Form.Item name="competitorDisplayMode">
      <StyledRadioGroup>
        <RadioButton value={CMA_SUMMARY_VIEW_FILTER_DISPLAY_COMPETITOR.DISPLAY_ALL}>
          Display All (Printer Friendly)
        </RadioButton>
        <RadioButton value={CMA_SUMMARY_VIEW_FILTER_DISPLAY_COMPETITOR.PAGINATE}>Paginate</RadioButton>
      </StyledRadioGroup>
    </Form.Item>
  </div>
);

export default CMASummaryViewFilterCompetitorsDisplay;
